/* eslint-disable no-magic-numbers */
const protocol = window.location.hostname.includes('market') ? 'https://' : 'http://'
// const hostname = window.location.hostname.includes("localhost")
//   ? "10.20.20.200"
//   : window.location.hostname;
//   : // : window.location.port === "3002"
//     // ? `${window.location.hostname}:5800/api`
// : `${window.location.hostname}:${import.meta.env.VITE_PORT}`;
const preEndpointEBM = window.location.hostname.includes('market')
  ? import.meta.env.VITE_API_ENDPOINT_EBM
  : ':5800/api'

const ebuyLoginHostname = window.location.hostname.includes('market')
  ? `www.${window.location.hostname.slice(7)}`
  : `${window.location.hostname}:5173`

const hostnameScroll = window.location.hostname.includes('market')
  ? 'www.e-buytest.com.ar'
  : window.location.hostname

const hostFinal = import.meta.env.VITE_API_TEST || window.location.hostname

export const API_ENDPOINT_EBM = protocol + hostFinal + preEndpointEBM
// export const API_ENDPOINT_EBM = "http://localhost:5000/api";
// export const API_ENDPOINT_EBP =
//   protocol + hostname + process.env.VITE_URL_LOGIN_EBP;
// export const API_ENDPOINT_EBP_RECOVERPWD =
//   protocol + hostname + process.env.VITE_URL_RECOVERPWD_EBP;
export const API_ENDPOINT_EBP_SCROLL = `${protocol + hostnameScroll}/scrollempresas.asp`

export const logoutURL = protocol + ebuyLoginHostname

//export const TEMP_IDUSUARIO = localStorage.getItem("idUsuario"); //localstorage generada en el login
// export const TEMP_IDUSUARIO = parseInt(localStorage.getItem("idUsuario"));
//hasta tener el JWT activado para autenticación

// Function to get user ID - preferably from context, fallback to localStorage
// export const getUserId = () => {
//   // This will be used in components that have access to context
//   // For cases where context is not available, we fallback to localStorage
//   return parseInt(localStorage.getItem("idUsuario")) || 0;
// };

// export const TEMP_USUARIO_PAIS = 1; //hasta tener el JWT activado para autenticación
